"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var postchain_client_1 = require("postchain-client");
var account_1 = require("../account");
var SingleSignatureAuthDescriptor = /** @class */ (function () {
    function SingleSignatureAuthDescriptor(pubkey, flags, rule) {
        if (rule === void 0) { rule = null; }
        this.rule = rule;
        this.flags = new account_1.Flags(new Set(flags));
        this.pubkey = pubkey;
    }
    Object.defineProperty(SingleSignatureAuthDescriptor.prototype, "signers", {
        get: function () {
            return [this.pubkey];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SingleSignatureAuthDescriptor.prototype, "id", {
        get: function () {
            return this.hash();
        },
        enumerable: true,
        configurable: true
    });
    SingleSignatureAuthDescriptor.prototype.toGTV = function () {
        return [
            account_1.AuthType.single_sig,
            [this.pubkey.toString('hex')],
            [this.flags.toGTV(), this.pubkey.toString('hex')],
            this.rule && this.rule.toGTV()
        ];
    };
    SingleSignatureAuthDescriptor.prototype.hash = function () {
        return postchain_client_1.gtv.gtvHash([
            account_1.AuthType.single_sig,
            [this.pubkey],
            [this.flags.toGTV(), this.pubkey.toString('hex')],
            this.rule && this.rule.toGTV()
        ]);
    };
    return SingleSignatureAuthDescriptor;
}());
exports.default = SingleSignatureAuthDescriptor;
//# sourceMappingURL=single-signature-auth-descriptor.js.map